import InPageNavItem from './item';
export default InPageNavItem;
